exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".agent-div-header  {\n\n}\n.agent-div-content {\n  border-bottom-left-radius: 25px;\n  border-bottom-right-radius: 25px;\n  padding: 10px;\n  background: yellow;\n}", ""]);

// exports
